/**
 * Pre-compiled pt-BR messages for MoneyInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  amountInputLabel: `Valor`,
  currencySelectLabel: `Moeda`,
  highPrecisionPrice: `Preço de alta precisão`,
};
